import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Drawer,
  MenuItem,
  Link
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
//import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useContext  } from "react";
//import { FcGoogle } from 'react-icons/fc';
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from '@mui/material/IconButton';
//import { GoogleLogin, GoogleLogout  } from 'react-google-login';
//import { gapi } from 'gapi-script';
//import jwt_decode from "jwt-decode";

//import { useGoogleLogin } from '@react-oauth/google';
import { useGoogleLogin, googleLogout, GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
//import { refreshTokenSetup } from "../refreshToken";
import { Context } from '../context';
import Subscriptions from "../subscriptions";



const useStyles = makeStyles((theme) => ({
  
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: 64,                 // match your CSS padding-top
    boxSizing: "border-box",
    paddingRight: "79px",
    paddingLeft: "118px",
    zIndex:
      theme && theme.zIndex && typeof theme.zIndex.appBar !== "undefined"
        ? theme.zIndex.appBar
        : 1200,                 // ensure header sits above footer
    backgroundColor: theme?.palette?.primary?.main || "#3F51B5", // Updated to match logo color
    "@media (max-width: 900px)": {
      paddingLeft: 0,
      height: 72,
    },
  },
  logo: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: 600,
    color: "#FFFEFE",
    textAlign: "left",
  },
  menuButton: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 800, // Using numeric value for extra boldness
    size: "18px",
    marginLeft: "30px", // Adjusted spacing between menu items
    marginRight: "30px", // Added right margin for more balanced spacing
    letterSpacing: "1px", // Improved text spacing
    fontSize: "14px", // Consistent font size
    textTransform: "uppercase", // Make all uppercase
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center", // Ensure vertical alignment
    paddingRight: "20px", // Add right padding to match dealprice.ca
  },
  menuContainer: {
    display: "flex",
    justifyContent: "flex-end", // Right-align the menu items
    alignItems: "center",
    width: "75%", // Force the menu container to take more space
    textAlign: "right" // Ensure text alignment for all items
  },
  drawerContainer: {
    padding: "20px 30px",
  },
}));

const headersData = [
  {
    label: "Search",
    href: "/productsearch",
  },
  {
    label: "Subscriptions",
    href: "/subscriptions",
  },
  {
    label: "Price Dropped",
    href: "/price-dropped",
  },
  {
    label: "About",
    href: "/about",
  },
  {
    label: "Sign In",
    href: "",
  }
];

export default function Header() {
  //const { emailId, setEmailId } = useContext(Context);
  const [emailId, setEmailId ] = useState([]);//string
  const [ profile, setProfile ] = useState({});//object
  const clientId = `${process.env.REACT_APP_GOOGLE_CLIENTID}`;
  
  // Extract all styles at component level
  const classes = useStyles();
  const { header, logo, menuButton, toolbar, menuContainer, drawerContainer } = classes;

  const onSuccess = (res) => {
    console.log("on success method called");
    setProfile(res.profileObj);
    //setEmailId(res.profileObj.email);
    if(res.profileObj) {
      localStorage.setItem("emailId", res.profileObj.email);
      /*window.dispatchEvent(new Event("storage"));*/
    }
    //refreshTokenSetup(res);
    

  };

  const onFailure = (err) => {
      console.log('failed', err);
  };

 const handleGoogleCredential = async (credentialResponse) => {
  try {
    const idToken = credentialResponse?.credential; // <-- ID token (JWT)
    if (!idToken) {
      console.error("No id token received from GoogleLogin");
      return;
    }

    // Optional: decode locally to show user immediately (not a substitute for backend verification)
    try {
      const decoded = jwtDecode(idToken);
      const profileObj = {
        email: decoded.email,
        name: decoded.name,
        picture: decoded.picture,
      };
      setProfile(profileObj);
      localStorage.setItem("emailId", profileObj.email);
    } catch (e) {
      console.warn("Failed to decode id_token locally", e);
    }

    // Send idToken to backend for verification / sign-in
    // Use proxy (e.g. package.json "proxy": "http://localhost:8080") OR set REACT_APP_API_BASE
    const apiBase = process.env.REACT_APP_PRODUCTFETCHER_URL || "";
    const resp = await fetch(`${apiBase}/api/auth/google`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ idToken }),
    });

    if (!resp.ok) {
      console.error("Backend verification failed", await resp.text());
      return;
    }

    const data = await resp.json();
    // backend should return profile info and/or your app session token
    const profileFromBackend = data.profile || data;
    if (profileFromBackend?.email) {
      setProfile(profileFromBackend);
      localStorage.setItem("emailId", profileFromBackend.email);
    }
    if (data.token) {
      // your app's session token / JWT returned by backend
      localStorage.setItem("authToken", data.token);
    }
  } catch (e) {
    console.error("Error verifying id token with backend", e);
  }
};

  const logOut = () => {
      // clear local state and tokens
      try { googleLogout(); } catch(e){/*ignore*/ }
      setProfile(null);
      localStorage.removeItem("emailId");
      localStorage.removeItem("authToken");
      window.location.reload();
  };


  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false
  });

  const { mobileView, drawerOpen  } = state;


  // Loading the user profile if it exists in localStorage
  useEffect(() => {
    // Check for existing session
    const storedEmail = localStorage.getItem("emailId");
    const storedAuthToken = localStorage.getItem("authToken");
    
    // If there's a stored email but no profile loaded yet, try to fetch user details
    if (storedEmail && storedAuthToken && (!profile || !profile.email)) {
      console.log("Found stored credentials, attempting to restore session");
      
      try {
        // Try to decode the token as a JWT first (ID token approach)
        const decodedToken = jwtDecode(storedAuthToken);
        console.log("Token decoded successfully during session restoration");
        
        // If decoding works, it's an ID token - use decoded info directly
        setProfile({
          email: decodedToken.email,
          name: decodedToken.name || decodedToken.given_name,
          picture: decodedToken.picture
        });
        console.log("Session restored from ID token");
      } catch (decodeError) {
        // If decoding fails, it might be an access token - try using it with Google API
        console.log("Token could not be decoded as JWT, trying as access token");
        
        fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: {
            'Authorization': `Bearer ${storedAuthToken}`
          }
        })
          .then(response => {
            // If token is valid, get the profile information
            if (response.ok) {
              return response.json();
            } else {
              // If token is invalid, clear localStorage
              console.log("Stored token is invalid, clearing session");
              localStorage.removeItem("emailId");
              localStorage.removeItem("authToken");
              throw new Error('Invalid token');
            }
          })
          .then(data => {
            console.log("Session restored successfully from access token");
            setProfile({
              email: data.email,
              name: data.name || data.given_name,
              picture: data.picture
            });
          })
          .catch(error => {
            console.error("Error restoring session:", error);
          });
      }
    }

    console.log("Environment(node_env, depends on command used to start the app): " + `${process.env.NODE_ENV}`);
    console.log("Environment: " + `${process.env.REACT_APP_ENVIRONMENT}`);

    console.log("Profile in Header useEffect: " + profile);
    console.log("Email in Header useEffect: " + (profile && profile.email));
    
    const setResponsiveness = () => {
      return window.innerWidth < 900
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    }
  }, []);

  const getGoogleLoginButtonsDesktop = () => {
    if (profile && profile.email) {
      return (
        <div style={{ display: "inline" }}>
          <Button
            key="signout"
            onClick={logOut}
            color="inherit"
            to=""
            component={RouterLink}
            className={menuButton}
          >
            SIGN OUT
          </Button>
          <div style={{ display: "inline", marginLeft: "38px" }}>
            Welcome {profile.name} !
          </div>
        </div>
      );
    }

    return (
      <Button
        key="signin"
        onClick={() => handleGoogleSignInClick()}
        color="inherit"
        to=""
        component={RouterLink}
        className={menuButton}
        style={{ fontWeight: 800 }} // Inline style to ensure maximum boldness
      >
        SIGN IN
      </Button>
    );
  };

  // Function to handle click on SIGN IN button that directly redirects to Google OAuth
  const handleGoogleSignInClick = () => {
    // Direct redirect to Google login - matches behavior on dealprice.ca
    const redirectUri = encodeURIComponent(window.location.origin);
    // Use response_type=id_token to request an ID token (JWT) instead of an access token
    // The backend expects an ID token for verification
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=id_token&scope=email+profile&prompt=consent&nonce=${Date.now()}`;
  };

  // Process the ID token from URL after Google redirect
  useEffect(() => {
    // Check for ID token in URL hash (after redirect from Google)
    const handleHash = () => {
      const hash = window.location.hash;
      if (hash.includes('id_token')) {
        // Extract ID token (JWT)
        const idToken = hash
          .substring(1)
          .split('&')
          .find(item => item.startsWith('id_token='))
          .split('=')[1];

        if (idToken) {
          console.log("ID token found in URL");
          
          try {
            // Decode the ID token locally to get user info
            const decoded = jwtDecode(idToken);
            console.log("ID token decoded:", decoded);
            
            // Create profile object from decoded token
            const profileObj = {
              email: decoded.email,
              name: decoded.name || decoded.given_name,
              picture: decoded.picture
            };
            
            // Update state and localStorage
            setProfile(profileObj);
            localStorage.setItem("emailId", profileObj.email);
            localStorage.setItem("authToken", idToken); // Store ID token as authToken
            
            // Clear hash from URL to avoid token exposure
            window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
            
            // Optionally verify with backend
            const apiBase = process.env.REACT_APP_PRODUCTFETCHER_URL || "";
            fetch(`${apiBase}/api/auth/google`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ idToken }),
            })
            .then(response => {
              if (!response.ok) {
                console.warn("Backend verification returned non-OK status:", response.status);
                return;
              }
              return response.json();
            })
            .then(data => {
              if (data && data.token) {
                // If backend provides its own token, use that instead
                localStorage.setItem("authToken", data.token);
              }
            })
            .catch(error => {
              console.error("Error verifying with backend:", error);
            });
          } catch (e) {
            console.error("Error processing ID token:", e);
          }
        }
      }
    };
    
    handleHash();
  }, []);

  

  const getGoogleLoginButtonsMobile = () => {
    if (profile && profile.email) {
      return (
        <div style={{ display: "inline" }}>
          <Link
            key="signout"
            onClick={logOut}
            color="inherit"
            to=""
            component={RouterLink}
            style={{ textDecoration: "none" }}
          >
            <MenuItem>SIGN OUT</MenuItem>
          </Link>
          <div style={{ marginLeft: "18px" }}>Welcome {profile.name} !</div>
        </div>
      );
    }

    return (
      <Link
        key="signin"
        onClick={() => handleGoogleSignInClick()}
        color="inherit"
        to=""
        component={RouterLink}
        style={{ textDecoration: "none" }}
      >
        <MenuItem>SIGN IN</MenuItem>
      </Link>
    );
  };

  const displayMobile = () => {
    const handleDrawerOpen = () =>
    setState((prevState) => ({ ...prevState, drawerOpen: true }));

    const handleDrawerClose = () =>
    setState((prevState) => ({ ...prevState, drawerOpen: false }));

    const getDrawerChoices = () => {
      return headersData.map(({ label, href }) => {
        if (label !== "Sign In") {
          const linkProps = {
            component: RouterLink,
            to: href,
            color: "inherit",
            style: { textDecoration: "none" },
          };
          return (
            <Link key={label} {...linkProps}>
              <MenuItem>{label}</MenuItem>
            </Link>
          );
        } else {
          return getGoogleLoginButtonsMobile();
        }
      });
    };

    return (
      <Toolbar>
        <IconButton
          {...{
            edge: "start",
            color: "inherit",
            "aria-label": "menu",
            "aria-haspopup": "true",
            onClick: handleDrawerOpen,
          }}
        >
          <MenuIcon />
        </IconButton>
        <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
          <div className={drawerContainer}>{getDrawerChoices()}</div>
          
        </Drawer>
        <div>{siteLogo}</div>
        
      </Toolbar>
    );
  };

  const displayDesktop = () => {
   // console.log("profile email: " + profile.email);
    return <Toolbar className={toolbar}>
              {siteLogo}       
              <div className={menuContainer} style={{ display: "flex", alignItems: "center" }}>{getMenuButtons()}</div>
            </Toolbar>;
      };

  const siteLogo = (
    <Typography variant="h6" component="h1" className={logo}>
      <div style={{marginRight:"20px"}}>
          <img style={{width:75,height:65}} src="../../images/logo-color.png" />
      </div>
    </Typography>
  );

   const getMenuButtons = () => {
    return headersData.map(({ label, href }) => {
      if (label !== "Sign In") {
        const btnProps = {
          color: "inherit",
          to: href,
          component: RouterLink,
          className: menuButton,
          style: { fontWeight: 800 } // Inline style to ensure maximum boldness
        };
        return (
          <Button key={label} {...btnProps}>
            {label}
          </Button>
        );
      } else {
        return getGoogleLoginButtonsDesktop();
      }
    });
  };



  return (
    <header>
      <AppBar position="fixed" className={header} elevation={4}>
        {mobileView ? displayMobile() : displayDesktop()}
      </AppBar>
      {/* No hidden components needed with direct popup approach */}
    </header>
  );
}
